import React from "react";
import clsx from "clsx";

export interface SegmentedTabOption<T extends string> {
  label: string;
  value: T;
  icon?: React.ReactNode;
}

interface SegmentedTabsProps<T extends string> {
  options: SegmentedTabOption<T>[];
  selected: T;
  onChange: (value: T) => void;
}

export default function SegmentedTabs<T extends string>({
  options,
  selected,
  onChange,
}: SegmentedTabsProps<T>) {
  return (
    <div className="inline-flex items-center gap-2 rounded-lg bg-primary-50 p-1">
      {options.map((option) => {
        const isSelected = option.value === selected;

        return (
          <button
            type="button"
            key={option.value}
            onClick={() => onChange(option.value)}
            className={clsx(
              "inline-flex items-center gap-1.5 rounded-md px-4 py-2 text-sm font-medium transition-colors",
              isSelected
                ? "bg-primary-200 text-primary-600"
                : "bg-transparent text-neutral-500 hover:bg-white hover:text-neutral-700",
            )}
          >
            {option.icon}
            <span>{option.label}</span>
          </button>
        );
      })}
    </div>
  );
}
